export default __webpack_public_path__ + "static/media/sushi.4b15c8ee.png";